import { render, staticRenderFns } from "./customer-message.vue?vue&type=template&id=6ed47a4a&"
import script from "./customer-message.vue?vue&type=script&lang=js&"
export * from "./customer-message.vue?vue&type=script&lang=js&"
import style0 from "./customer-message.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports